import React, { Component } from "react";
import {
  Row,
  Col,
  UncontrolledAlert,
  Card,
  Button,
  CardHeader,
  CardBody,
} from "reactstrap";
import { MdAdd } from "react-icons/md";
import Formsy from "formsy-react";
import { Spinner } from "../../Shared";
import { TextInput } from "../../Shared/Forms";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";
class CategoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      run: false,
      stepIndex: 0,
      steps: [
        {
          target: tourMessages.adminCategoryForm.target,
          content: (
            <div>
              <p>{tourMessages.adminCategoryForm.title}</p>
              <p
                style={{ color: "blue", fontStyle: "italic", fontSize: "10px" }}
              >
                {tourMessages.adminCategoryForm.content}
              </p>
            </div>
          ),
          placement: "left",
          locale: { skip: "SKIP" , close: 'Next'},        },
        tourMessages.default,
      ],
    };
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  createRequest = data => {
    let request = { ...data };
    if (request.interestCode) {
      request = {
        interestId: request.interestCode.id,
        ...request,
      };
      delete request.interestCode;
    }
    return request;
  };

  handleSubmit = data => {
    let requestBody = this.createRequest(data);
    this.props.submitAction(requestBody);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitSucessful) {
      this.resetForm();
    }
    if (nextProps.showNextJoyRide) {
      this.setState({ run: true });
      this.props.setNextJoyRide();
    }
  }

  resetForm = () => {
    this.refs.categoryForm.reset();
  };

  ClearDescription = () => {
    this.props.reset();
    this.resetForm();
  };

  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.startJoyRideAtDataTable();
      }
    }
  };

  render() {
    const { canSubmit, run, steps, stepIndex } = this.state;
    const { submitting, error, hasParams, selectedRow } = this.props;
    return (
      <div>
        <Joyride
          steps={steps}
          scrollToFirstStep
          showProgress
          showSkipButton
          styles={{
            options: {
              width: 200,
              height: 60,
              zIndex: 1000,
            },
          }}
          callback={this.handleJoyrideCallback}
          run={run}
          stepIndex={stepIndex}
        />
        <Row>
          <Col>
            <Card>
              <CardHeader>{hasParams ? "Edit" : "Create"} Category</CardHeader>
              <CardBody>
                {error ? (
                  <UncontrolledAlert color="danger">
                    {error.message}
                  </UncontrolledAlert>
                ) : null}
                <Formsy
                  ref="categoryForm"
                  onValidSubmit={this.handleSubmit}
                  onValid={this.enableButton}
                  onInvalid={this.disableButton}
                  noValidate
                >
                  <TextInput
                    name="name"
                    value={selectedRow && hasParams ? selectedRow.name : null}
                    required
                    disabled={submitting}
                    title="Category"
                    validations={{
                      minLength: 3,
                      maxLength: 50,
                    }}
                    validationErrors={{
                      minLength: "Minimum of 3 characters allowed",
                      maxLength: "Maximum of 50 characters allowed",
                    }}
                  />
                  <TextInput
                    name="description"
                    required
                    value={
                      hasParams && selectedRow ? selectedRow.description : null
                    }
                    disabled={submitting}
                    title="Description"
                    validations={{
                      minLength: 5,
                    }}
                    validationErrors={{
                      minLength: "Minimum of 5 characters allowed",
                      maxLength: "Maximum of 50 characters allowed",
                    }}
                  />
                  <Button
                    type="submit"
                    color="primary"
                    disabled={!canSubmit || submitting}
                    className="joyride4"
                  >
                    {submitting ? (
                      <Spinner size="sm" />
                    ) : (
                      <span>
                        {hasParams ? "Update" : "Create"} <MdAdd size={20} />
                      </span>
                    )}
                  </Button>{" "}
                  {hasParams ? (
                    <Button
                      type="button"
                      outline
                      color="primary"
                      onClick={() => this.ClearDescription()}
                    >
                      Reset
                    </Button>
                  ) : null}
                </Formsy>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CategoryForm;
